(function() {
  function dispatchCartUpdate(itemCount) {
    const event = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        data: {
          itemCount: itemCount,
          source: 'product-form-component'
        }
      }
    });
    document.dispatchEvent(event);
  }

  // Intercept fetch-based add-to-cart
  const origFetch = window.fetch;
  window.fetch = function() {
    const url = arguments[0];
    if (typeof url === 'string' && url.includes('/cart/add')) {
      return origFetch.apply(this, arguments).then(function(res) {
        res.clone().json().then(function(data) {
          dispatchCartUpdate(data.quantity || 1);
        }).catch(function() {
          fetch('/cart.js').then(r => r.json()).then(cart => dispatchCartUpdate(cart.item_count));
        });
        return res;
      });
    }
    return origFetch.apply(this, arguments);
  };

  // Catch form-based submissions too
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      setTimeout(function() {
        fetch('/cart.js').then(r => r.json()).then(cart => dispatchCartUpdate(cart.item_count));
      }, 800);
    }
  });
})();
